export default __webpack_public_path__ + "static/media/mission-bg.7ea0e0df.webp";